import { ImportCsvOptionsButton } from '@framework/engine';
import { IWidgetCsvConfig } from '@framework/engine/src/schema/widgets/repository/inputs/common/option-list/WidgetCsvField';
import { FormItem, TextInput, useRelationEditor } from '@framework/form';
import { VerticalSpace } from '@framework/ui';
import { Empty, Typography } from 'antd';
import {
  IWidgetCascadeCombination,
  IWidgetCascadeField,
} from '../IMultiPreferenceWidget';

export interface IMultiPreferenceOptionsInputProps {}

export function MultiPreferenceOptionsInput(
  props: IMultiPreferenceOptionsInputProps,
) {
  const fieldsRelation =
    useRelationEditor<IWidgetCascadeField>('cascade.fields');
  const combinationsRelation = useRelationEditor<IWidgetCascadeCombination>(
    'cascade.combinations',
  );

  const onImport = (data: IWidgetCsvConfig) => {
    fieldsRelation.replace(data.fields);
    combinationsRelation.replace(data.combinations);
  };

  return (
    <div>
      <VerticalSpace size={12} />
      {fieldsRelation.items?.map((item, i) => (
        <div key={item.__uid}>
          <FormItem
            name={`cascade.fields.${i}.label`}
            label={`Colonna ${i + 1}`}
          >
            <TextInput
              style={{ width: '100%' }}
              name={`cascade.fields.${i}.label`}
              placeholder={`Etichetta della colonna ${i + 1}`}
            />
          </FormItem>
        </div>
      ))}
      {(!fieldsRelation.items?.length ||
        !combinationsRelation.items?.length) && (
        <Empty description="Nessuna opzione impostata" />
      )}
      <ImportCsvOptionsButton
        onImport={onImport}
        options={{ allowOneColumn: true }}
      />
      <Typography.Paragraph>
        Incolla un CSV con le opzioni delle preferenze. Il CSV può contenere una
        o più colonne, dove ogni riga rappresenta una combinazione di opzioni.
        Non includere l&apos;intestazione.
      </Typography.Paragraph>
    </div>
  );
}
